import Service from '@ember/service';
import { service } from '@ember/service';
import TabLink from '@ebiz/ember-aditools-ipc/utils/tab-link';

const TIMEOUT = 10000; // 10 seconds

/////////////////////////////////////////////////////////////////////////////////
// channel - service for communicating with another web applicaion via SignalR //
/////////////////////////////////////////////////////////////////////////////////

export default class ChannelService extends Service {
  @service('aditools-site') siteconfig;
  @service logger;
  connection = null;
  invokerId = null;
  isConnectionActive = null;
  selfLink = null;

  setInvokerId(id) {
    this.invokerId = id;
  }

  connect(eventList, handShakeTimeOut) {
    let selfRef = this;
    console.time('Handshake');
    handShakeTimeOut.timeOut = setTimeout(() => handShakeTimeOut.handlerFunc(), TIMEOUT);
    this.selfLink = new TabLink(window.opener, {
      id: this.invokerId,
      isInitiator: false,
      verbose: true,
      onConnect: () => {
        this.logger.log(`On Connect Event Raised!`);
        if (eventList['onConnect']) eventList['onConnect']();
        selfRef.isConnectionActive = true;
      },
      onDisconnect: (clean) => {
        this.logger.log(`On Disconnect Event Raised!` + (clean ? ' (Clean)' : ''));
        if (eventList['onDisconnect']) eventList['onDisconnect']();
        selfRef.invokerId = null;
        selfRef.isConnectionActive = false;
      },
      onData: (data) => {
        this.logger.log(`On Data Event Raised!`);
        if (eventList['onData']) eventList['onData'](data);
      },
    });
  }

  disconnect() {
    this.selfLink.disconnect();
  }

  sendDesign(designData, designTimeOut) {
    console.time('Send Design');
    try {
      designTimeOut.timeOut = setTimeout(() => designTimeOut.handlerFunc(), TIMEOUT);
      this.selfLink.send({ type: 'design', design: designData });
    } catch (err) {
      console.timeEnd('Send Design');
      this.logger.error(`Send Design to Parent failed: ${err}`);
    }
  }
}
